locations-index
  forms-locations-search(tag-scope="forms_locations_search")
  locations-table(tag-scope="locations_table")
  script(type="typescript").
    this.mixin('base');
